// extracted by mini-css-extract-plugin
export var attachmentContainer = "_j8-0";
export var fileList = "_j8-2";
export var removeFileButton = "_j8-1";